<template>
  <div
    class="loader"
    :style="{ backgroundColor: background, opacity }"
  ><div></div><div></div><div></div><div></div></div>
</template>

<script>
export default {
  name: 'Loader',

  props: {
    background: {
      type: String,
      required: false,
      default: '#FFF',
    },

    opacity: {
      type: String,
      required: false,
      default: '0.7',
    },
  },
};
</script>

<style lang="scss" scoped>
  .loader {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    justify-content: center;
    display: flex;
    align-content: center;

    div {
      position: absolute;
      top: 50%;
      width: 13px;
      height: 13px;
      border-radius: 50%;
      background: theme('colors.primary.500');
      animation-timing-function: cubic-bezier(0, 1, 1, 0);
      left: calc(50% - 7.5px);

      &:nth-child(1) {
        margin-left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
      }

      &:nth-child(2) {
        margin-left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
      }

      &:nth-child(3) {
        margin-left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
      }

      &:nth-child(4) {
        margin-left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
      }
    }

  }

  @keyframes lds-ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes lds-ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes lds-ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
</style>
